// extracted by mini-css-extract-plugin
export default {"title":"CatalogsTableInput_title__1Xkv5"};